'use client';
import * as styles from './styles.css';
export { styles as menuStyles };
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useRef, useState, useLayoutEffect, useEffect } from 'react';
import { LoadingSpinner } from '@paypalcorp/pp-react-loading-spinner';
import { uniqueId, getPx, hasWindow, hasDocument, cx, KeyboardCode } from '@paypalcorp/pp-react-utils';
import { Sheet } from '@paypalcorp/pp-react-sheet';
import { breakpoints } from '@paypalcorp/pp-react-theme';
import { List, getSelectableIndex } from '@paypalcorp/pp-react-list';

var _excluded$1 = ["name", "value", "className", "containerClassName", "itemClassName", "mobileHeaderClassName", "sheetClassName", "sheetWrapperClassName", "id", "initialItemFocus", "isOpen", "ignoreKeyboard", "mobileTitle", "mobileHeaderContents", "outsideClickCheck", "onOpen", "onClose", "onSelection", "options", "returnFocusToTrigger", "selectedIndex", "activeItem", "triggerElementId", "triggerElementRef", "rtl", "isLoadingOptions", "searchEnabled", "mobileFixedHeight", "hasSections", "highlightText", "isTextHighlighted"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * Sigh... We need this if you want to use useState() from a "global" event handler
 * Otherwise you will get the old value of state and it won't ever appear to change.
 * This stores the state (to get refresh) and also stashes it into a ref, which
 * will always be up-to-date
 *
 * Love, BCC
 */
function useReferredState(initialValue) {
  var _React$useState = React.useState(initialValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  var reference = React.useRef(state);
  return [reference, function setReferredState(value) {
    reference.current = value;
    setState(value);
  }];
}
var SelectionMenu = function (_ref) {
  _ref.name;
    var value = _ref.value,
    className = _ref.className,
    containerClassName = _ref.containerClassName,
    itemClassName = _ref.itemClassName,
    mobileHeaderClassName = _ref.mobileHeaderClassName,
    sheetClassName = _ref.sheetClassName,
    sheetWrapperClassName = _ref.sheetWrapperClassName,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? uniqueId('selectionMenu_') : _ref$id,
    _ref$initialItemFocus = _ref.initialItemFocus,
    initialItemFocus = _ref$initialItemFocus === void 0 ? true : _ref$initialItemFocus,
    isOpen = _ref.isOpen,
    ignoreKeyboard = _ref.ignoreKeyboard,
    mobileTitle = _ref.mobileTitle,
    mobileHeaderContents = _ref.mobileHeaderContents,
    outsideClickCheck = _ref.outsideClickCheck,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    onSelection = _ref.onSelection,
    options = _ref.options,
    _ref$returnFocusToTri = _ref.returnFocusToTrigger,
    returnFocusToTrigger = _ref$returnFocusToTri === void 0 ? true : _ref$returnFocusToTri,
    _ref$selectedIndex = _ref.selectedIndex,
    selectedIndex = _ref$selectedIndex === void 0 ? 0 : _ref$selectedIndex,
    _ref$activeItem = _ref.activeItem,
    activeItem = _ref$activeItem === void 0 ? -1 : _ref$activeItem,
    triggerElementId = _ref.triggerElementId,
    triggerElementRef = _ref.triggerElementRef,
    _ref$rtl = _ref.rtl,
    rtl = _ref$rtl === void 0 ? false : _ref$rtl,
    _ref$isLoadingOptions = _ref.isLoadingOptions,
    isLoadingOptions = _ref$isLoadingOptions === void 0 ? false : _ref$isLoadingOptions,
    _ref$searchEnabled = _ref.searchEnabled,
    searchEnabled = _ref$searchEnabled === void 0 ? false : _ref$searchEnabled,
    mobileFixedHeight = _ref.mobileFixedHeight,
    _ref$hasSections = _ref.hasSections,
    hasSections = _ref$hasSections === void 0 ? false : _ref$hasSections,
    _ref$highlightText = _ref.highlightText,
    highlightText = _ref$highlightText === void 0 ? null : _ref$highlightText,
    _ref$isTextHighlighte = _ref.isTextHighlighted,
    isTextHighlighted = _ref$isTextHighlighte === void 0 ? false : _ref$isTextHighlighte,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var wrapperRef = useRef();
  var menuRef = useRef();
  var loaderRef = useRef();
  var searchText = useRef('');
  var typeToFindTimer;
  var hasOptions = options && options.length > 0;
  var _useReferredState = useReferredState(initialItemFocus ? selectedIndex : -1),
    _useReferredState2 = _slicedToArray(_useReferredState, 2),
    focusedIndexRef = _useReferredState2[0],
    setFocusedIndex = _useReferredState2[1];
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    keyboardActive = _useState2[0],
    setKeyboardActive = _useState2[1];

  // min and max width for ul/li
  var MIN_WIDTH = getPx(styles.menuListWidthMin);
  var MAX_WIDTH = getPx(styles.menuListWidthMax);
  var MEDIUM_BREAKPOINT = getPx(breakpoints.mediaMd);

  /* istanbul ignore next */
  var isMobile = hasWindow() ? window.innerWidth < MEDIUM_BREAKPOINT : false;
  var getRefCurrent = function (ref) {
    return /* istanbul ignore next */(
      ref && ref.current ? ref.current : null
    );
  };

  /**
   * To enable support for `shadow-dom` get the trigger element from `ref` or by `id`
   */

  var TRIGGER_ELEMENT = function getTriggerElement() {
    var triggerElement = getRefCurrent(triggerElementRef);

    /* istanbul ignore next */
    if (triggerElement) {
      return triggerElement;
    }

    // need to check existence of document object for SSR
    if (triggerElementId && hasDocument()) {
      return document.getElementById(triggerElementId);
    }
    return null;
  }();
  var calculateWidth = function () {
    var triggerWidth = TRIGGER_ELEMENT === null || TRIGGER_ELEMENT === void 0 ? void 0 : TRIGGER_ELEMENT.getBoundingClientRect().width;

    /* istanbul ignore next */
    if (isLoadingOptions) {
      var loader = getRefCurrent(loaderRef);
      loader.style.width = triggerWidth ? "".concat(triggerWidth, "px") : "".concat(MAX_WIDTH, "px");
    } else {
      var menu = getRefCurrent(menuRef);
      if (!menu) {
        return;
      }
      var menuWidth = menu.getBoundingClientRect().width;
      /* istanbul ignore next */
      if (triggerWidth > MIN_WIDTH && triggerWidth > menuWidth) {
        menu.style.width = "".concat(triggerWidth, "px");
      }
    }
  };

  /* Create a flat list of suggestions for highlight and selection by index */
  var normalizeSuggestions = function (suggestions) {
    return suggestions.reduce(function (acc, section) {
      /* istanbul ignore next */
      if (section === null || section === void 0 ? void 0 : section.suggestions) {
        acc.push.apply(acc, _toConsumableArray(section.suggestions));
      }
      return acc;
    }, []);
  };
  var handleClickOutside = function (evt) {
    var wrapperCurrent = getRefCurrent(wrapperRef);

    // Trigger click is also handled here in React 17
    var isTriggerClicked = TRIGGER_ELEMENT === null || TRIGGER_ELEMENT === void 0 ? void 0 : TRIGGER_ELEMENT.contains(evt.target);

    // istanbul ignore next
    if ((!outsideClickCheck || outsideClickCheck(evt)) && !isTriggerClicked) {
      if (wrapperCurrent && !wrapperCurrent.contains(evt.target)) {
        onClose(evt, 'backdropClick');
      }
    }
  };
  var findValue = function (optionsList, value) {
    return optionsList.findIndex(function (option) {
      return value === option.value || value === option.label;
    });
  };
  var handleClick = function (evt) {
    var _evt$target;
    var target = (_evt$target = evt.target) === null || _evt$target === void 0 ? void 0 : _evt$target.parentElement;
    var index = hasSections ? findValue(normalizeSuggestions(options), target.dataset.value) : findValue(options, target.dataset.value);
    setFocusedIndex(index);
    onSelection(index, evt);
  };

  /* istanbul ignore next */
  var getFirstPrefixPosition = function () {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var typedText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return list.findIndex(function (option) {
      return option.label.toLowerCase().startsWith(typedText.toLowerCase());
    });
  };

  /* eslint-disable complexity */
  var handleKey = function (evt) {
    evt.preventDefault();
    var focusedIndex = focusedIndexRef.current;
    /* istanbul ignore next */
    var KeyCode = new KeyboardCode(evt.key || evt.keyCode);
    var listOptions = hasSections ? normalizeSuggestions(options) : options;
    if (KeyCode.IS_ARROW_UP) {
      setKeyboardActive(true);
      if (focusedIndex > 0) {
        setFocusedIndex(getSelectableIndex(listOptions, focusedIndex, 'previous'));
      }
    } else if (KeyCode.IS_ARROW_DOWN) {
      setKeyboardActive(true);
      if (focusedIndex < listOptions.length - 1) {
        setFocusedIndex(getSelectableIndex(listOptions, focusedIndex, 'next'));
      }
    } else if (KeyCode.IS_ENTER) {
      onSelection(focusedIndex, evt);
    } else if (KeyCode.IS_TAB || KeyCode.IS_ESC) {
      var closedBy = KeyCode.IS_TAB ? KeyboardCode.NAME_TAB : KeyboardCode.NAME_ESC;

      // We don't need to call onClose if we have a sheet -- it will do that for us!
      /* istanbul ignore next */
      if (typeof onClose === 'function' && !isMobile) {
        onClose(evt, closedBy);
      }

      // eslint-disable-next-line no-unused-expressions
      TRIGGER_ELEMENT === null || TRIGGER_ELEMENT === void 0 ? void 0 : TRIGGER_ELEMENT.focus();
    } else if (searchEnabled && evt.key.length === 1) {
      // Since we're handling keydown event, we might get values like
      // 'Shift' or 'Alt'. We don't want to search unless it's a single character

      clearTimeout(typeToFindTimer);
      searchText.current = searchText.current + evt.key;
      // Clear the typeToFindText if user doesn't consecutively type keys between 700 milliseconds
      //istanbul ignore next
      typeToFindTimer = setTimeout(function () {
        searchText.current = '';
      }, 700);
      var firstMatchedItemIndex = getFirstPrefixPosition(options, searchText.current);
      if (firstMatchedItemIndex >= 0) {
        setKeyboardActive(true);
        setFocusedIndex(firstMatchedItemIndex);
      }
    }
  };
  /* eslint-enable complexity */

  var handleKeyDown = function (evt) {
    handleKey(evt);
  };

  /* We need this method because we're trying to support index-based and
   * value-based operation at the same time. If we revert to only using
   * value-based, this code can get much simpler
   */

  var selectedValue = function getSelectedValue(currentValue, defaultValue) {
    if (currentValue !== undefined) {
      return currentValue;
    }
    // istanbul ignore next
    if (selectedIndex !== undefined && selectedIndex >= 0) {
      if (hasSections) {
        var tempOtps = normalizeSuggestions(options);
        if (tempOtps && tempOtps[selectedIndex] && tempOtps[selectedIndex].value !== undefined) {
          return tempOtps[selectedIndex].value;
        }
      } else if (options && options[selectedIndex] && options[selectedIndex].value !== undefined) {
        return options[selectedIndex].value;
      }
    }
    return defaultValue;
  }(value);
  var focusedIndex = ignoreKeyboard ? -1 : focusedIndexRef.current;
  var renderOptionList = function () {
    var listOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : options;
    if (isOpen && hasOptions) {
      return listOptions.map(function (option, idx) {
        // We have to test against false because non-existence means it's selectable
        var optionValue = option.hasOwnProperty('value') ? option.value : option.label;

        // istanbul ignore next
        var isSelected = !option.unselectable && (selectedValue === undefined ? selectedIndex === idx : optionValue === selectedValue);
        return _objectSpread(_objectSpread({}, option), {}, _defineProperty(_defineProperty({
          decoration: option.decoration ? {
            thumbnail: option.decoration,
            align: 'center'
          } : null,
          trailingContent: {
            align: 'center'
          },
          className: itemClassName,
          onClick: handleClick,
          role: 'option',
          isSelected: isSelected
        }, 'data-value', optionValue), "value", optionValue));
      });
    }
    return [];
  };
  var renderSectionOptionList = isOpen && hasOptions ? options.map(function (option) {
    return {
      title: option.title,
      id: option.id,
      sectionItems: renderOptionList(option.suggestions)
    };
  }) : [];
  useLayoutEffect(function () {
    if (isOpen && !isMobile) {
      calculateWidth();
    }
    if (isOpen && hasOptions) {
      // Bind the event listener
      // @ts-ignore
      document.addEventListener('click', handleClickOutside);
      if (!ignoreKeyboard) {
        document.body.addEventListener('keydown', handleKeyDown);
      }
      if (!isMobile) {
        setKeyboardActive(initialItemFocus);
        // istanbul ignore next
        if (focusedIndex < 0) {
          setFocusedIndex(0);
        }
      } else {
        // set keyboard focus active to false, on mobile we don't show the focus indicator
        setKeyboardActive(false);
      }
      if (typeof onOpen === 'function') {
        onOpen(isMobile);
      }
    }
    return function () {
      // @ts-ignore
      document.removeEventListener('click', handleClickOutside);
      if (!ignoreKeyboard) {
        document.body.removeEventListener('keydown', handleKeyDown);
      }
      setKeyboardActive(false);
    };
  }, [isOpen, isLoadingOptions]);

  //pass dir manually to fix styles in sheet rtl
  //set to null in ltr so the attribute is not added
  /* istanbul ignore next */
  var direction = rtl ? 'rtl' : null;
  var optionList = hasSections ? renderSectionOptionList : renderOptionList(options);
  var contentList = optionList && /*#__PURE__*/React.createElement(List, _extends({
    className: cx(styles.menuList, className),
    id: id,
    tabIndex: 0,
    "aria-hidden": !isOpen,
    hasSections: !!hasSections,
    ref: menuRef,
    dir: direction,
    options: optionList,
    activeIndex: activeItem,
    focusedIndex: focusedIndex,
    focusActive: !isMobile && keyboardActive,
    highlightText: highlightText,
    isTextHighlighted: isTextHighlighted
  }, rest, {
    "data-ppui": "true"
  }));
  var loadingSpinner = /*#__PURE__*/React.createElement("div", {
    ref: loaderRef,
    className: styles.menuLoadingContainer,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    screenReaderText: "loading",
    size: "md",
    "data-ppui": "true"
  }));
  var content = isLoadingOptions ? loadingSpinner : contentList;
  return function bodyWrapper() {
    if (isMobile) {
      // istanbul ignore next
      var isFixedHeight = mobileHeaderContents ? '90' : undefined;
      return /*#__PURE__*/React.createElement(Sheet, {
        isOpen: isOpen,
        onCloseComplete: onClose,
        title: mobileTitle,
        headerClassName: mobileHeaderClassName,
        headerContents: mobileHeaderContents,
        noPadding: true,
        noCloseButton: false,
        mobileFixedHeight: mobileFixedHeight || isFixedHeight,
        className: sheetClassName,
        wrapperClassName: sheetWrapperClassName,
        returnFocusToTrigger: returnFocusToTrigger,
        "data-ppui": "true"
      }, content);
    }
    return isOpen && /*#__PURE__*/React.createElement("div", {
      ref: wrapperRef,
      className: cx(styles.menuContainer, containerClassName),
      "data-ppui-info": "selection-menu_4.1.5__8.12.2-beta.0"
    }, content);
  }();
};

var _excluded = ["className", "containerClassName", "itemClassName", "id", "initialItemFocus", "isOpen", "mobileTitle", "isLoadingOptions", "options", "onClose", "onSelection", "triggerRef", "mobileFixedHeight", "overrideMobileView"];
var getRefCurrent = function (ref) {
  return /* istanbul ignore next */(
    ref && ref.current ? ref.current : null
  );
};
var ActionMenu = function (_ref) {
  var className = _ref.className,
    containerClassName = _ref.containerClassName,
    itemClassName = _ref.itemClassName,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? uniqueId('actionMenu_') : _ref$id,
    _ref$initialItemFocus = _ref.initialItemFocus,
    initialItemFocus = _ref$initialItemFocus === void 0 ? true : _ref$initialItemFocus,
    isOpen = _ref.isOpen,
    mobileTitle = _ref.mobileTitle,
    _ref$isLoadingOptions = _ref.isLoadingOptions,
    isLoadingOptions = _ref$isLoadingOptions === void 0 ? false : _ref$isLoadingOptions,
    options = _ref.options,
    onClose = _ref.onClose,
    onSelection = _ref.onSelection,
    triggerRef = _ref.triggerRef,
    mobileFixedHeight = _ref.mobileFixedHeight,
    _ref$overrideMobileVi = _ref.overrideMobileView,
    overrideMobileView = _ref$overrideMobileVi === void 0 ? false : _ref$overrideMobileVi,
    rest = _objectWithoutProperties(_ref, _excluded);
  var MEDIUM_BREAKPOINT = getPx(breakpoints.mediaSm);
  var containerRef = useRef();
  var menuRef = useRef();
  var validateOptions = options && options.length;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    keyboardActive = _useState4[0],
    setKeyboardActive = _useState4[1];

  /* istanbul ignore next */
  var isMobile = !overrideMobileView && hasWindow() ? window.innerWidth < MEDIUM_BREAKPOINT : false;
  var handleClickOutside = function (evt) {
    var wrapperCurrent = getRefCurrent(containerRef);
    // triggerRef is required for React 17
    if (wrapperCurrent && !wrapperCurrent.contains(evt.target) && triggerRef && !triggerRef.current.contains(evt.target)) {
      onClose(evt);
    } else if (!triggerRef && wrapperCurrent && !wrapperCurrent.contains(evt.target)) {
      onClose(evt);
    }
  };

  /* eslint-disable complexity */

  /* eslint-enable complexity */

  useEffect(function () {
    /* istanbul ignore next */
    if (isOpen) {
      var firstFocusIndex = options.findIndex(function (x) {
        return x.unselectable !== true;
      });
      if (!isMobile) {
        // setFocus(0)
        setSelectedIndex(firstFocusIndex);
        setKeyboardActive(initialItemFocus);
      }
      document.addEventListener('click', handleClickOutside);
      window.addEventListener('resize', onClose);
    } else {
      document.removeEventListener('click', handleClickOutside);
      window.removeEventListener('resize', onClose);
    }
    return function () {
      setSelectedIndex(0);
      setKeyboardActive(false);
      document.removeEventListener('click', handleClickOutside);
      window.removeEventListener('resize', onClose);
    };
  }, [isOpen, options]);
  var optionList = validateOptions ? /*#__PURE__*/React.createElement(List, _extends({
    options: options.map(function (_ref2, optionIndex) {
      var decoration = _ref2.decoration,
        label = _ref2.label,
        navigationOptions = _ref2.navigationOptions,
        unselectable = _ref2.unselectable;
      return {
        decoration: decoration ? {
          thumbnail: decoration
        } : null,
        label: label,
        unselectable: unselectable,
        className: itemClassName,
        onClick: !navigationOptions ? function (event) {
          return onSelection(optionIndex, event);
        } : null,
        navigationOptions: navigationOptions
      };
    }),
    focusActive: keyboardActive,
    focusedIndex: selectedIndex,
    className: cx(styles.menuList, className),
    id: id,
    role: "menu",
    "aria-hidden": !isOpen,
    ref: menuRef,
    onKeyDown: function handleKey(evt) {
      evt.preventDefault();
      /* istanbul ignore next */
      var KeyCode = new KeyboardCode(evt.key || evt.keyCode);
      var triggerEl = getRefCurrent(triggerRef);
      if (KeyCode.IS_ARROW_UP) {
        setKeyboardActive(true);
        setSelectedIndex(getSelectableIndex(options, selectedIndex, 'previous'));
      } else if (KeyCode.IS_ARROW_DOWN) {
        setKeyboardActive(true);
        setSelectedIndex(getSelectableIndex(options, selectedIndex, 'next'));
      } else if (KeyCode.IS_ENTER) {
        onSelection(selectedIndex, evt);
        var anchor = evt.target;
        /* istanbul ignore next */
        if (anchor.href) {
          anchor.click();
        }
      } else if (KeyCode.IS_TAB || KeyCode.IS_ESC) {
        onClose(evt);
      }
      if ((KeyCode.IS_TAB || KeyCode.IS_ESC || KeyCode.IS_ENTER) && triggerEl) {
        triggerEl.focus();
      }
    }
  }, rest, {
    "data-ppui": "true"
  })) : null;
  var listItems = isLoadingOptions ? /*#__PURE__*/React.createElement("div", {
    className: styles.menuLoadingContainer,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    screenReaderText: "loading",
    size: "md",
    "data-ppui": "true"
  })) : optionList;
  var container = isMobile ? /*#__PURE__*/React.createElement(Sheet, {
    title: mobileTitle,
    isOpen: isOpen,
    onCloseComplete: onClose,
    noPadding: true,
    mobileFixedHeight: mobileFixedHeight,
    "data-ppui": "true"
  }, listItems) : /*#__PURE__*/React.createElement("nav", {
    className: cx(styles.menuContainer, containerClassName),
    ref: containerRef,
    "data-ppui-info": "action-menu_4.1.5__8.12.2-beta.0"
  }, listItems);
  return isOpen && container;
};

export { ActionMenu, SelectionMenu };
